import { ConfigProvider, App as AntdApp } from 'antd'
import { ThemeProvider } from 'antd-style'

import { Router } from '@eastcoal/router/components/Router'

import { themeConfig } from './config/antd'
import { customToken } from './config/antd-style'
import { routes } from './routes'

export const App = () => {
  return (
    <ThemeProvider customToken={customToken}>
      <ConfigProvider {...themeConfig}>
        <AntdApp>
          <Router items={routes} />
        </AntdApp>
      </ConfigProvider>
    </ThemeProvider>
  )
}
